<template>
  <v-row>
    <v-col cols="12" class="pa-1">
      <OpenBatchInformation :data="data"/>
    </v-col>
    <v-col
      v-for="column in columns"
      :key="column.key"
      class="pa-1"
    >
      <draggable :handle="!isEditing ? '.handle' : ''" :list="column.fields" group="dashboardCards"
        :class="isEditing ? 'dndgrab' : ''">
        <div v-for="field in displayedFields(column)" :key="field.id">
          <component
            @refreshDashboard="refreshDashboard"
            :class="isEditing ? 'dndborder' : ''"
            :is="field.value"
            :id="field.id"
            v-bind="field.attributes"
            :data="data"
            :activityPeriod="activityPeriod"
          />
        </div>
      </draggable>
    </v-col>
  </v-row>
</template>

<script>
import draggable from 'vuedraggable';
import RecentBatches from './RecentBatches.vue';
import RecentTransactions from './RecentTransactions.vue';
import SalesByType from './SalesByType.vue';
import OpenBatchInformation from './OpenBatchInformation.vue';
import Activity from './Activity.vue';

export default {
  props: {
    data: {
      required: true,
    },
    columns: {
      type: Array,
      required: true,
    },
    activityPeriod: {
      type: String,
      required: true,
    },
    isEditing: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    dollarFormattedValueOrZero(value) {
      return this.dollarFormattedValue(value) || '$0.00';
    },
    dollarFormattedValue(value) {
      const format = this.$options.filters.dollarsAndCents;
      return value ? `$${format(value)}` : null;
    },
    displayedFields(column) {
      return column.fields.filter((field) => !field.hidden);
    },
    refreshDashboard() {
      this.$emit('refreshDashboard');
    },
  },
  components: {
    OpenBatchInformation,
    Activity,
    RecentBatches,
    RecentTransactions,
    SalesByType,
    draggable,
  },
};
</script>
